<form (submit)="onFormSubmit($event)">
    <dx-form #MerchantwalletForm [formData]="formData" [colCount]="(screen.xSmallScreenChanged | async) ? 2 : colCount" labelLocation="left" [screenByWidth]="getSizeQualifier"
    labelMode="outside"
        (onFieldDataChanged)="onFieldChange(null,null,$event)">
        <dxi-item dataField="selectedMerchantId" editorType="dxSelectBox" [editorOptions]="{
                        items: merchantList,
                        displayExpr: 'CompanyName',
                        valueExpr: 'Id',
                        searchEnabled: true,
                        
                    } "><dxo-label text="Merchant"></dxo-label>
            <dxi-validation-rule type="required" message="Please select a merchant."></dxi-validation-rule>
        </dxi-item>

        <dxi-item *ngIf="selectedMerchant">
            <dxo-label text="Merchant Balance"></dxo-label>
            <div>{{ selectedMerchant.AccountBalance | currency:'R' }}</div>
        </dxi-item>

        <dxi-item dataField="walletId" editorType="dxSelectBox" [editorOptions]="{
                        items: walletList,
                        displayExpr: 'name',
                        valueExpr: 'id',
                        searchEnabled: true
                    } " [disabled]="!selectedMerchant"><dxo-label text="Wallet"></dxo-label>
            <dxi-validation-rule type="required" message="Please select a wallet."></dxi-validation-rule>
        </dxi-item>

        <dxi-item *ngIf="selectedWallet">
            <dxo-label text="Wallet Balance"></dxo-label>
            <div>{{ selectedWallet.balance | currency:'R' }}</div>
        </dxi-item>

        <dxi-item dataField="amount" [isRequired]="true" editorType="dxNumberBox" [editorOptions]="numberBoxOptions"
            [disabled]="!selectedWallet">
            <dxo-label text="Amount"></dxo-label>
            <dxi-validation-rule type="required" message="Amount is required"></dxi-validation-rule>
            <dxi-validation-rule type="numeric" message="Amount must be a number."></dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="0.1" message="Amount must be at least 0.1."></dxi-validation-rule>
            <dxi-validation-rule type="range" [max]="selectedMerchant?.AccountBalance!"
                message="The top-up amount may not exceed the merchant's available balance."></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item>
            <div *dxTemplate style="text-align: right;">
                <dx-button [text]="submitButtonOptions.text!" [type]="submitButtonOptions.type!"
                    [width]="submitButtonOptions.width!" [useSubmitBehavior]="submitButtonOptions.useSubmitBehavior!"
                    [disabled]="submitButtonOptions.disabled || !formValid">
                </dx-button>
            </div>

        </dxi-item>

    </dx-form>
</form>
